
export class archivedSite {
  siteUrl: string = '';
  id: string = '';
  name: string | null = null;
  ownersCount: number | null = null;
  ownersDetail: string = "";
  ownersDetailPending: string | null = null;
  nonValidOwnersDetail: string | null = null;
  nonExistingOwnersDetail: string | null = null;
  classification: string | null = null;
  template: string | null = null;
  archivedUntil: Date = new Date();
  complianceState: number | null = null;
  lastUpdated: Date = new Date();
  membersList: string | null = null;
  membersCount: number | null = null;
  externalMembersCount: number | null = null;
  sensitivityLabel: string | null = null;
  lastJobUpdateDate: Date | null = null;
  lastContentModifiedDate: Date | null = null;
  isConnected: string = "";
  m365GroupId: string | null = null;
  m365ResourceType: string = "";
  m365TeamId: string | null = null;
  requiredForRetention: string | null = null;
  businessJustification: string | null = null;
  ownersList: string[] = [];
  readOnlyOwners: string[] = [];
  archivedBy: string = "";
  lastKnownSizeByte: string = "";

}
